export const makeRequest = async (requestUrl, method = "GET") => {
  let header = {
    method,
    credentials: "include"
  };
  let response = {};
  response = await fetch(requestUrl, header)
    .then(checkStatus)
    .then(parseResponse)
    .catch(error => {
      throw error;
    });
  return response;
};

const checkStatus = response => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    // attempt to parse the response
    return parseResponse(response).then(
      () => {
        const error = new Error();
        error.response = response;
        throw error;
      },
      () => {
        const error = new Error(response.statusText);
        error.response = response;
        throw error;
      }
    );
  }
};

const parseResponse = response => {
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.indexOf("application/json") > -1) {
    return response.json();
  }
  return response.text();
};
